import { Linkedin, UserPlus } from 'lucide-react';

const teamMembers = [
  {
    name: 'Bui Xuan Quy',
    role: 'Founder & CEO',
    description:
      'Founder of AITOS Labs LLC. Operates the brand portfolio (Elzary and Avyra Atlas), the in-house storefront stack, and the AI ops stack across design, listing, fulfillment, and customer experience.',
    avatar: 'BQ',
    linkedin: 'https://www.linkedin.com/in/collin-bui/',
    type: 'member' as const,
  },
  {
    name: 'Growth Lead',
    role: 'Open role — hiring',
    description:
      'Owns marketplace strategy across Etsy, Amazon, and eBay, plus paid + organic growth loops for the brand portfolio.',
    avatar: '+',
    type: 'open' as const,
  },
  {
    name: 'Stack & AI Lead',
    role: 'Open role — hiring',
    description:
      'Builds and tunes the AITOS ops stack: listing engine, fulfillment router, CX agent, forecasting, and brand analytics.',
    avatar: '+',
    type: 'open' as const,
  },
];

const Team = () => {
  return (
    <section className="py-20 px-6 bg-gray-950" id="team">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-purple-400 text-xl mb-4 tracking-widest">ABOUT US</h2>
          <h3 className="text-5xl font-bold mb-3">The AITOS Team</h3>
          <p className="text-gray-300 max-w-3xl mx-auto">
            Operators first. We run the brands ourselves — design, marketplace, fulfillment, CX, and
            growth — and pair every function with AI tooling we build in-house.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {teamMembers.map((member) => {
            const isOpen = member.type === 'open';
            return (
              <div
                key={member.name}
                className={`rounded-xl p-6 text-center transition-all duration-300 ${
                  isOpen
                    ? 'bg-gray-900/50 border border-dashed border-gray-700'
                    : 'bg-gray-900 hover:transform hover:-translate-y-1 hover:shadow-2xl'
                }`}
              >
                <div className="relative w-32 h-32 mx-auto mb-6">
                  <div
                    className={`w-full h-full rounded-full flex items-center justify-center text-white text-2xl font-bold ${
                      isOpen
                        ? 'bg-gray-800 border border-dashed border-gray-700'
                        : 'bg-gradient-to-br from-purple-500 to-pink-500'
                    }`}
                  >
                    {isOpen ? <UserPlus size={36} className="text-gray-500" /> : member.avatar}
                  </div>
                  {!isOpen && member.linkedin && (
                    <a
                      href={member.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="absolute -bottom-2 -right-2 w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center hover:bg-purple-400 transition-colors"
                      aria-label={`${member.name} on LinkedIn`}
                    >
                      <Linkedin size={16} className="text-white" />
                    </a>
                  )}
                </div>
                <h4 className="text-xl font-bold mb-2">{member.name}</h4>
                <p className={`mb-4 text-sm ${isOpen ? 'text-purple-300' : 'text-gray-400'}`}>
                  {member.role}
                </p>
                <p className="text-sm text-gray-300">{member.description}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <a
            href="#cta"
            className="inline-flex items-center bg-gradient-to-r from-purple-500 to-pink-500 text-white font-medium px-8 py-4 rounded-full hover:opacity-90 transition-opacity"
          >
            Talk to the team
          </a>
        </div>
      </div>
    </section>
  );
};

export default Team;
